import { QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from '@tanstack/react-router'
import { StrictMode, useState } from 'react'
import { createRoot } from 'react-dom/client'
import { I18nProvider } from './lib/i18n'
import { createStaffApiClient, createStaffQueryClient, TRPCProvider } from './lib/trpc'
import { createBackOfficeRouter } from './router'
import './styles.css'

/*
 * The back office web (ADR 0008): its own entry, served only on its own host. Nothing of the
 * portal's routes, API client or texts is part of it (entry.test.ts).
 */

const router = createBackOfficeRouter()

function App() {
  const [queryClient] = useState(createStaffQueryClient)
  const [apiClient] = useState(createStaffApiClient)
  return (
    <QueryClientProvider client={queryClient}>
      <TRPCProvider trpcClient={apiClient} queryClient={queryClient}>
        <I18nProvider>
          <RouterProvider router={router} />
        </I18nProvider>
      </TRPCProvider>
    </QueryClientProvider>
  )
}

const root = document.getElementById('root')
if (!root) throw new Error('Root element missing')
createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
